import React        from 'react';
import { render }   from 'react-dom';
import Pokemon      from './components/Pokemon';

import 'bootstrap/dist/css/bootstrap.css';

render(<Pokemon />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js